// extracted by mini-css-extract-plugin
export default {"language-picker":"kGzgONB","language-picker__visually-hidden":"PANkSGw","language-picker__select":"Gb7V3Rj","language-picker__icon":"EGb6mC4"};